import { IVideoPlaylistDetail } from '../../types';

export const MOCK_VIDEO_PLAYLIST = [
  { videoFormat: 'Video', entry_id: '1_pwlb3mje' },
  { videoFormat: 'Video', entry_id: '1_gtlm8jf4' },
  { videoFormat: 'Video', entry_id: '1_4uitn2po' },
];

export const videoPlaylistDetailsMock: IVideoPlaylistDetail[] = [
  {
    entry_id: '1',
    videoData: {
      videoTitle: 'Video 1',
      userKeyKs: '',
      videoDescription: '',
      videoViews: '30',
      videoDuration: '10',
    },
    videoFormat: 'mp4',
  },
  {
    entry_id: '2',
    videoData: {
      videoTitle: 'Video 2',
      userKeyKs: '',
      videoDescription: '',
      videoViews: '40',
      videoDuration: '1000',
    },
    videoFormat: 'mp4',
  },
  {
    entry_id: '3',
    videoData: {
      videoTitle: 'Video 3',
      userKeyKs: '',
      videoDescription: '',
      videoViews: '50',
      videoDuration: '1000',
    },
    videoFormat: 'mp4',
  },
];

export const DESKTOP_WIDTH = 768;
export const MOBILE_WIDTH = DESKTOP_WIDTH + 1;
